/* GD House — retour à la page fidélité après authentification (retour client 03/08).

   PROBLÈME
   Les boutons de la page Programme de fidélité sont générés par l'app Essential Loyalty et
   pointent tous vers /customer_authentication/login?return_to=/ — donc vers l'ACCUEIL après
   authentification. Le visiteur clique « Rejoignez dès maintenant », s'authentifie, et se
   retrouve sur la page d'accueil sans aucun signe qu'il a rejoint le programme. S'il est déjà
   connecté, l'aller-retour est instantané : le clic semble ne rien faire.

   POURQUOI CE CORRECTIF EST CÔTÉ THÈME
   Les blocs de l'app n'exposent aucun réglage de redirection (vérifié dans l'éditeur). On ne
   touche pas au fichier de l'app, qui est régénéré à chaque mise à jour : on se contente de
   réécrire le paramètre return_to des liens qu'elle produit.

   POURQUOI RÉÉCRIRE L'ATTRIBUT PLUTÔT QU'INTERCEPTER LE CLIC
   Modifier href garde la sémantique normale du lien : clic milieu, ouverture dans un nouvel
   onglet, « copier l'adresse du lien » restent corrects. Un preventDefault + redirection
   casserait tout ça.

   POURQUOI UN MutationObserver
   Le contenu est rendu par Alpine.js APRÈS le chargement, et il peut remplacer ces liens.
   Une seule passe au chargement ne suffirait donc pas.

   NOTE : sur une preview de thème, Shopify redirige de toute façon myshopify.com vers le
   domaine principal et perd le preview_theme_id. On propage location.search dans return_to
   pour limiter la casse, mais la sortie de preview elle-même n'est pas contournable. */

(function () {
  'use strict';

  var SELECTOR = 'a.essential-button[href*="/customer_authentication/login"]';

  function fixLink(a) {
    var raw = a.getAttribute('href');
    if (!raw) return;
    var url;
    try {
      url = new URL(raw, window.location.origin);
    } catch (e) {
      return; // href inexploitable : on ne casse rien, on laisse tel quel
    }
    var back = window.location.pathname + window.location.search;
    if (url.searchParams.get('return_to') === back) return; // déjà corrigé
    url.searchParams.set('return_to', back);
    a.setAttribute('href', url.pathname + url.search);
  }

  /* ------------------------------------------------------------------
     Onglet « about:blank » sur les boutons du hero connecté.

     Pour un client authentifié, l'app génère :
       <a href="javascript:void(0);" onclick="…scrollIntoView…"
          target="_blank" rel="noreferrer noopener">Voir les GDCoins</a>

     Le onclick fait bien défiler la page, mais target="_blank" demande au navigateur
     d'ouvrir « javascript:void(0) » dans un nouvel onglet — qui reste donc vide.
     Les deux comportements se cumulent : la page défile ET un onglet vide s'ouvre.

     On retire le target uniquement quand la destination ne mène nulle part
     (javascript:, vide ou #). Les vrais liens externes gardent leur _blank. */
  function fixTarget(a) {
    var href = (a.getAttribute('href') || '').trim().toLowerCase();
    var inerte = href === '' || href === '#' || href.indexOf('javascript:') === 0;
    if (!inerte) return;
    a.removeAttribute('target');
  }

  function fixAll() {
    document.querySelectorAll(SELECTOR).forEach(fixLink);
    document.querySelectorAll('a.essential-button[target="_blank"]').forEach(fixTarget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAll);
  } else {
    fixAll();
  }

  /* Alpine réécrit le DOM après le chargement : on repasse sur les liens recréés. */
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          fixAll();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------------
     Défilement vers les sections « gagner » / « échanger ».

     Reprend l'intention d'un script qui vivait dans theme.liquid et qui rendait TOUTE la page
     inerte : il appelait preventDefault + stopImmediatePropagation sur chaque .essential-button,
     puis ne cherchait une cible que si le libellé contenait « earn » ou « redeem ». Sur une
     boutique en français, aucun libellé ne correspond : les liens de connexion ne naviguaient
     plus, et les boutons Alpine (newsletter, anniversaire, réseaux) ne réagissaient plus non
     plus, puisque stopImmediatePropagation coupait aussi leurs propres écouteurs.

     Deux différences ici :
       - on ne bloque le comportement par défaut QUE si une cible existe vraiment ;
       - on ne touche jamais à la propagation, donc les écouteurs de l'app continuent de vivre.
     ------------------------------------------------------------------ */

  var ANCRES = [
    { mots: ['earn', 'gagn'], cible: '.essential-ways-to-earn' },
    { mots: ['redeem', 'chang', 'depens'], cible: '.essential-ways-to-redeem' }
  ];

  /* « Échangez » / « Dépensez » : on compare sans accents pour ne pas dépendre de la casse
     ni des diacritiques. \\u0300-\\u036f = les marques combinantes laissées par NFD. */
  function sansAccents(s) {
    return s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.essential-button');
    if (!btn) return;
    var texte = sansAccents(btn.textContent || '');
    var cible = null;
    for (var i = 0; i < ANCRES.length && !cible; i++) {
      for (var j = 0; j < ANCRES[i].mots.length; j++) {
        if (texte.indexOf(ANCRES[i].mots[j]) !== -1) {
          cible = document.querySelector(ANCRES[i].cible);
          break;
        }
      }
    }
    if (!cible) return; // rien à faire : le lien ou le bouton garde son comportement normal
    e.preventDefault();
    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    cible.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'start' });
  });
})();
